module.exports = __webpack_public_path__ + "img/undraw_meet_the_team_e5b7.1f2673cf.svg";